import React, { useMemo } from 'react';
import { UserData } from '../types';

interface MentionDropdownProps {
    query: string;
    following: string[];
    usersData: Record<string, UserData>;
    onSelect: (username: string) => void;
    className?: string;
    position?: 'above' | 'below';
}

export const MentionDropdown: React.FC<MentionDropdownProps> = ({
    query,
    following,
    usersData,
    onSelect,
    className = "",
    position = 'above'
}) => {
    const results = useMemo(() => {
        const lowerQuery = query.toLowerCase();
        return following
            .map(username => ({ username, data: usersData[username] }))
            .filter(({ username, data }) => {
                if (!data) return false;
                return (
                    username.toLowerCase().includes(lowerQuery) ||
                    data.displayName.toLowerCase().includes(lowerQuery)
                );
            })
            .slice(0, 3); // Limit to 3 results
    }, [query, following, usersData]);

    if (results.length === 0) return null;

    return (
        <div className={`absolute z-[100] bg-[#1b1b1f]/95 backdrop-blur-xl border border-white/10 rounded-xl shadow-2xl overflow-hidden min-w-[100px] ${position === 'above' ? 'bottom-full mb-2' : 'top-full mt-2'} ${className}`}>
            <div className="py-0.5">
                {results.map(({ username, data }) => (
                    <button
                        key={username}
                        onClick={() => onSelect(username)}
                        className="w-full flex items-center gap-1.5 px-2 py-1 hover:bg-white/5 transition-colors text-left"
                    >
                        {data.pfp ? (
                            <img src={data.pfp} alt="" className="w-10 h-10 rounded-full object-cover" />
                        ) : (
                            <div
                                className="w-4 h-4 rounded-full flex items-center justify-center text-white text-[10px] font-bold"
                                style={{ backgroundColor: data.appThemeColor || '#2563eb' }}
                            >
                                {data.displayName[0]?.toUpperCase()}
                            </div>
                        )}
                        <div className="flex flex-col min-w-0">
                            <span className="text-[12px] font-bold text-white truncate leading-tight">
                                {data.displayName}
                            </span>
                            <span className="text-[10px] text-gray-400 truncate leading-tight">
                                @{username}
                            </span>
                        </div>
                    </button>
                ))}
            </div>
        </div>
    );
};
